module.exports = __webpack_public_path__ + "img/times-circle.6832fc6d.svg";